module.exports = __webpack_public_path__ + "static/media/lineto-circular-bold.da46404a.woff2";